import { GridOptions } from 'ag-grid-community';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridAngular } from 'ag-grid-angular';
import { OAuthService } from 'angular-oauth2-oidc';
import { NgbStringAdapter } from '../common/convertors/ngbstringadapter';
import { AssignGateway } from '../common/models/assigngateway';
import { GatewayFilter } from '../common/models/gatewayfilter';
import { GatewayFirmware } from '../common/models/gatewayfirmware';
import { FCToasterService } from '../common/toaster/FCToasterService';
import { Service } from '../service';
import { GatewayDecommission } from './../common/models/gatewaydecommission';
import { unitSearchService } from '../common/unitSearchService';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { GatewayInfoComponent } from '../gateway-info/gateway-info.component';
import { PermissionService } from '../services/permission.service';
import { MasterDataService } from '../services/master-data.service';

@Component({
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.scss'],
  standalone: false
})
export class GatewayComponent implements OnInit {
  permissionService: PermissionService;
  title = 'appBootstrap';
  @ViewChild("agGridGateway", { static: false }) agGridGateway: AgGridAngular;
  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup;
  @ViewChild(GatewayInfoComponent) gatewaySyncInfo: GatewayInfoComponent;

  rowData: any[];
  columnDefs: any[];
  gatewayTypes: any[];
  gatewayTypeSelectedId: number;
  fmGatewayTypeSelectedId: number;
  gatewayTypeSelectedValue: any;
  countries: any[];
  txtGWSrchUnit: any = "";
  gridOptions: GridOptions;
  closeResult: string;
  isRowSelected: boolean = false;
  rowSelectedData: {};
  txtGWMLUnitNum: any;
  txtGWMlRemType: any;
  txtGWMlMacAdd: any;
  txtGWMlIccId: any;
  txtGWMlIccId2: any;
  GWFMVersion: any;
  txtGWFirmwareVersion: any;
  selectedGatewayType: any = {};
  gatewaySearchFilter = {} as GatewayFilter;
  date = new Date();
  assignGateway = {} as AssignGateway;
  lblErrorGWMLMacAdd = "";
  lblErrorGWFWVersionAdd = "";
  lblErrorGWMLType = "";
  selectedUnitsInfo = [];
  selectedUnits = [];
  gatewayDecommission = {} as GatewayDecommission;
  addGatewayFirmware = {} as GatewayFirmware;
  gatewayUpdateEnable: boolean = true;
  TxtGMfwVersion: any;
  TempTxtGMfwVersion: string;
  isAdmin: boolean = false;
  txtGWPwd = "";
  lblVersionMessage = "";
  isBtnEndGateway: boolean = true;
  lblErrorGWPwd = "";
  txtSuggestedVersion = "";
  divTextColor: any;
  isSavedUpdated: boolean = false;
  Devicegateway: any;
  devicegatewayTypeSelId: number = 1;
  unitNumber: string;
  tempDataList: any[] = [];
  unitdeviceGatewayType: string;
  countryId: number;
  DefaultGatewayTypeText: string = "";
  DefaultGatewayTypeId: number = 0;
  DefaultMacAddress: string = "";
  isDoubleDeck: boolean = false;
  progress: number;
  isCGW: boolean = true;
  lblG3MSErrorMessage = "";
  lblConnectionStatus = "";
  isOnline = false;
  isValidSerialNumber = true;
  enableGatewaySync = false;
  gatewaySync: string = "";
  lblICCID2error = "";
  lblICCID2success = "";
  lblICCID1error = "";
  lblICCID1success = "";
  lblVerizonStatus = "";
  lblATTStatus = "";
  isVerizonActivation: boolean = false;
  isATTActivation: boolean = false;
  verizonDeviceInfo: any;
  attDeviceInfo: any;
  isInvalidSim1: boolean = false;
  isInvalidSim2: boolean = false;

  constructor(private apiService: Service, private modalService: NgbModal,
    private ngbStringAdapter: NgbStringAdapter, private toastr: FCToasterService,
    private oauthService: OAuthService, private unitSearch: unitSearchService,
    private permissionServiceParam: PermissionService,
    private masterDataService: MasterDataService) {
    this.permissionService = permissionServiceParam;
  }

  ngOnInit(): void {
    let claims = this.oauthService.getIdentityClaims();
    this.apiService
      .getUserDetails(claims["oid"])
      .subscribe({
        next: (data: any) => {
          if (data != null) {
            this.isAdmin = this.apiService.isAdmin();
            this.DefaultGatewayTypeId = data["defaultGatewayTypeId"];
          }
        },
        error: () => {
        }
      });
    this.bindGridOnPageLoad();
    this.bindMasterDataFilters();
    this.bindDefaultValuesOnPageLoad();
    this.checkUserPermissions();

    this.gridOptions = {
      defaultColDef: { filter: true },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: true,
      paginationAutoPageSize: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      headerHeight: 40,
      rowHeight: 32
    }
  }

  onChange(event: MatTabChangeEvent) {
    this.tabGroup._tabs.toArray()[3].disabled = true;
    const tab = event.tab.textLabel;
    if (tab === "Commission Gateway") {
      this.tabGroup._tabs.toArray()[0].disabled = true;
      this.tabGroup._tabs.toArray()[1].disabled = false;
      this.resetFilters();
    }
    else if (tab === "Gateway Sync") {
      this.tabGroup._tabs.toArray()[0].disabled = false;
      this.tabGroup._tabs.toArray()[1].disabled = true;
      this.gatewaySyncInfo.resetFilters();
    }
    else {
      this.tabGroup._tabs.toArray()[0].disabled = true;
      this.tabGroup._tabs.toArray()[1].disabled = true;
    }

  }

  //Grid Data bind in Commissioning page Load
  bindGridOnPageLoad() {
    this.columnDefs = [
      { headerName: "", field: "cbox", sortable: true, checkboxSelection: true, width: 50, flex: 0 },
      {
        headerName: "Gateway", valueGetter: function (res) {
          if (res.data.gatewayType == "Otis Mobiline") {
            return res.data.cgwConnectionStatus;
          } else {
            return res.data.digiConnectionStatus;
          }
        }, filter: false, field: "cgwConnectionStatus", minWidth: 110, flex: 1, tooltipField: "cgwConnectionStatus", headerTooltip: "Gateway", cellRenderer: params => { return this.bindDeviceStatus(params.value); }
      },
      {
        headerName: "AT&T", valueGetter: function (res) {
          const gatewayType = (res.data.gatewayType || "").toString();
          if (gatewayType.includes("DIGI")) {
            return res.data.attConnectionStatus;
          }
        }, filter: false, field: "attConnectionStatus", minWidth: 110, flex: 1, tooltipField: "attConnectionStatus", headerTooltip: "AT&T", cellRenderer: params => { return this.bindDeviceStatus(params.value); }
      },
      {
        headerName: "Verizon", valueGetter: function (res) {
          const gatewayType = (res.data.gatewayType || "").toString();
          if (gatewayType.includes("DIGI")) {
            return res.data.verizonConnectionStatus;
          }
        }, filter: false, field: "verizonConnectionStatus", minWidth: 110, flex: 1, tooltipField: "verizonConnectionStatus", headerTooltip: "Verizon", cellRenderer: params => { return this.bindDeviceStatus(params.value); }
      },
      { headerName: "Unit Number", field: "elevatorUnitNumber", sortable: true, minWidth: 160, flex: 1.6, tooltipField: "elevatorUnitNumber", headerTooltip: "Unit Number" },
      { headerName: "Building Name", field: "buildingName", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "buildingName", headerTooltip: "Building Name" },
      { headerName: "MAC Address/Serial Number", field: "gatewayMacAddress", sortable: true, minWidth: 270, flex: 2.7, resizable: true, tooltipField: "gatewayMacAddress", headerTooltip: "MAC Address/Serial Number" },
      { headerName: "Gateway Type", field: "gatewayType", sortable: true, minWidth: 180, flex: 1.8, tooltipField: "gatewayType", headerTooltip: "Gateway Type" },
      { headerName: "Building Address", field: "buildingAddress", sortable: true, minWidth: 300, flex: 3, resizable: true, tooltipField: "buildingAddress", headerTooltip: "Building Address" },
      { headerName: "CARLET", field: "carlet", sortable: true, minWidth: 150, flex: 1.5, resizable: true, tooltipField: "CARLET", headerTooltip: "CARLET" },
      { headerName: "CP-ID/UUID", field: "cpidUuid", sortable: true, minWidth: 200, flex: 2, resizable: true, tooltipField: "cpidUuid", headerTooltip: "CP-ID/UUID" },
      { headerName: "CP-ID/UUID2", field: "cpidUuid2", sortable: true, minWidth: 200, flex: 2, resizable: true, tooltipField: "cpidUuid2", headerTooltip: "CP-ID/UUID2" },
      { headerName: "Country Id", field: "countryId", sortable: true, width: 150, tooltipField: "countryId", headerTooltip: "Country Id", hide: "true" },
      { headerName: "Country", field: "countryName", sortable: true, minWidth: 200, flex: 2, tooltipField: "countryName", headerTooltip: "Country Name" },
      { headerName: "AT&T ICCID", field: "gatewayIccId", sortable: true, minWidth: 220, flex: 2.2, resizable: true, tooltipField: "gatewayIccId", headerTooltip: "AT&T ICCID" },
      { headerName: "Verizon ICCID", field: "gatewayIccId2", sortable: true, minWidth: 220, flex: 2.2, resizable: true, tooltipField: "gatewayIccId2", headerTooltip: "Verizon ICCID" },
      { headerName: "RemType Id", field: "remTypeId", sortable: true, minWidth: 150, flex: 1.5, tooltipField: "remTypeId", headerTooltip: "Rem Type" },

    ];
  }

  bindDeviceStatus(statusDesc) {
    return statusDesc === "Online" ? "<i class='fa fa-circle cGreen'></i>" :
      statusDesc === "Offline" ? "<i class='fa fa-circle cRed'></i>" : "";
  }
  //Bind master data in filters on page load
  bindMasterDataFilters() {
    setTimeout(() => {
      this.getGatewayTypes();
    }, 5000);

    this.getGatewayFirmwareVersion();
  }

  // Assign default values to variables on Page load
  bindDefaultValuesOnPageLoad() {
    this.txtGWMLUnitNum = "";
    this.txtGWMlRemType = "";
    this.txtGWMlMacAdd = this.DefaultMacAddress;
    this.txtGWMlIccId = "";
    this.txtGWMlIccId2 = "";
    this.gatewayTypeSelectedValue = this.DefaultGatewayTypeText;
    this.gatewayTypeSelectedId = this.DefaultGatewayTypeId;
    this.rowData = [];
    this.rowSelectedData = {};
    this.selectedUnits = [];
    this.isRowSelected = false;
    this.selectedUnitsInfo = [];
    this.gatewayUpdateEnable = true;
    this.isDoubleDeck = false;
    this.progress = 0;
    this.isCGW = true;
    this.lblG3MSErrorMessage = "";
    this.lblConnectionStatus = "";
    this.isOnline = false;
    this.isValidSerialNumber = true;
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.isATTActivation = false;
    this.verizonDeviceInfo = [];
    this.attDeviceInfo = [];
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;
  }

  getGridDataByFilterSearch() {
    this.bindDefaultValuesOnPageLoad();
    this.gatewaySearchFilter.searchField = (this.txtGWSrchUnit !== null && this.txtGWSrchUnit !== undefined) ? this.txtGWSrchUnit.trim() : "";
    if (this.txtGWSrchUnit != null && this.txtGWSrchUnit !== "") {
      this.gatewaySearchFilter.searchField = this.unitSearch.getUpdatedUnitSearch(this.txtGWSrchUnit);
      this.apiService
        .getUnitsByFilterSearch(this.gatewaySearchFilter)
        .subscribe((data: any) => {
          if (data != null) {
            this.rowData = data;
          }
          else {
            this.rowData = [];
          }
        });
    }
    else {
      this.toastr.showError("Please enter the Unit Number or Building Name or Address");
    }
    this.isSavedUpdated = false;
  }

  //Gateway Modal popup open
  open(content) {
    this.lblVersionMessage = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.verizonDeviceInfo = [];
    this.isATTActivation = false;
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;
    this.devicegatewayTypeSelId = 1; this.unitdeviceGatewayType = 'CPIB2';
    if (content._declarationTContainer.localNames[0] == 'decommModal') {
      if (this.rowSelectedData[0]["gatewayMacAddress"] != null && this.rowSelectedData[0]["gatewayMacAddress"] != '') {
        this.getUnitDeviceGateway(false);
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    }
    else if (content._declarationTContainer.localNames[0] == 'gatewayModal' && !this.gatewayUpdateEnable) {
      this.unitdeviceGatewayType = "";
      this.getUnitDeviceGateway(true);
      if (this.rowSelectedData[0].gatewayType != "Otis Mobiline") {
        this.checkDigiFirmwareVersion();
        if (!this.gatewayUpdateEnable && this.rowSelectedData != "") {
          this.txtGWMlMacAdd = this.rowSelectedData[0]["gatewayMacAddress"];
          this.checkFirmwareProgress(false);
        }
      }
      else {
        this.getCGWConnectionStatus();
      }
      this.modalService.open(content, { windowClass: "myCustomModalClass", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else if (content._declarationTContainer.localNames[0] == 'gatewayModal' && this.gatewayUpdateEnable) {
      this.modalService.open(content, { windowClass: "myCustomModalClass", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  // Dismss Modal Popup
  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onKeyEnter() {
    this.getGridDataByFilterSearch();
  }

  // Close Modal Popup
  modalClose(isfirmware = false) {
    this.modalService.dismissAll();
    this.lblErrorGWMLMacAdd = "";
    this.lblErrorGWFWVersionAdd = "";
    this.lblErrorGWMLType = "";
    this.gatewayTypeSelectedValue = this.DefaultGatewayTypeText;
    this.gatewayTypeSelectedId = this.DefaultGatewayTypeId;
    this.txtGWMlMacAdd = this.DefaultMacAddress;
    this.txtGWMlIccId = "";
    this.txtGWMlIccId2 = "";
    this.TxtGMfwVersion = "";
    this.txtGWFirmwareVersion = "";
    this.getGatewayFirmwareVersionName(this.gatewayTypeSelectedId);
    this.txtGWPwd = "";
    this.lblVersionMessage = "";
    this.lblErrorGWPwd = "";
    this.txtSuggestedVersion = "";
    if (!isfirmware) { this.getGridDataByFilterSearch(); }
    this.progress = 0;
    this.isCGW = true;
    this.lblG3MSErrorMessage = "";
    this.lblConnectionStatus = "";
    this.isOnline = false;
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.isATTActivation = false;
    this.verizonDeviceInfo = [];
    this.attDeviceInfo = [];
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;
  }

  //Grid row selection event
  onRowSelected(event) {
    if (event.node.selected) {
      if (this.selectedUnitsInfo.length > 0 && event.node.data.buildingName !== this.selectedUnitsInfo[0]["buildingName"]) {
        this.toastr.showError("Selected units should be in same building");
        event.api.deselectAll();
        this.selectedUnitsInfo = []; this.selectedUnits = [];
      }
      else if (this.selectedUnitsInfo.length > 0 && event.node.data.gatewayMacAddress !== this.selectedUnitsInfo[0]["gatewayMacAddress"]) {
        this.toastr.showError("Selected units should have same gateway MacAddress");
        event.api.deselectAll();
        this.selectedUnitsInfo = []; this.selectedUnits = [];
      }
      else if (this.selectedUnitsInfo.length > 0 && event.node.data.gatewayIccId !== this.selectedUnitsInfo[0]["gatewayIccId"]) {
        this.toastr.showError("Selected units should have same SimcardIccId");
        event.api.deselectAll();
        this.selectedUnitsInfo = []; this.selectedUnits = [];
      }
      else {
        this.selectedUnitsInfo.push(event.node.data);
        this.selectedUnits.push(event.node.data.elevatorUnitNumber);
      }

      if (this.selectedUnitsInfo.length > 0 && this.selectedUnitsInfo[0]["gatewayMacAddress"].length > 6) {
        this.gatewayUpdateEnable = false;
      }
      else {
        this.gatewayUpdateEnable = true;
      }
    }

    else {
      var index = this.selectedUnitsInfo.indexOf(event.node.data);
      if (index >= 0) {
        this.selectedUnitsInfo.splice(index, 1);
        this.selectedUnits.splice(index, 1);
      }
      this.gatewayUpdateEnable = true;
    }

    if (this.selectedUnitsInfo.length >= 1 && this.selectedUnitsInfo.length <= 4) {
      this.isRowSelected = true;
      this.rowSelectedData = this.selectedUnitsInfo;
      this.unitNumber = this.rowSelectedData[0].elevatorUnitNumber;
      this.countryId = this.rowSelectedData[0].countryId;
      this.GatewayModalLoad(this.rowSelectedData[0])
    }
    else {
      this.isRowSelected = false;
      this.rowSelectedData = {};
    }

    if (this.selectedUnitsInfo.length > 4) {
      this.toastr.showWarning("Please Select upto maximum 4 unit(s) to commission a Gateway");
    }
  }

  GatewayModalLoad(rowSelectedData) {
    this.isDoubleDeck = false;
    this.isCGW = true;
    this.lblG3MSErrorMessage = "";
    this.lblConnectionStatus = "";
    this.isOnline = false;
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.verizonDeviceInfo = [];
    this.isVerizonActivation = false;
    this.isATTActivation = false;
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;
    this.attDeviceInfo = [];
    this.txtGWMlMacAdd = (rowSelectedData["gatewayMacAddress"] !== null && rowSelectedData["gatewayMacAddress"] !== undefined && rowSelectedData["gatewayMacAddress"] !== "") ? rowSelectedData["gatewayMacAddress"] : this.DefaultMacAddress;
    this.gatewayTypeSelectedValue = (rowSelectedData["gatewayType"] !== null && rowSelectedData["gatewayType"] !== undefined && rowSelectedData["gatewayType"] !== "") ? rowSelectedData["gatewayType"] : this.DefaultGatewayTypeText;
    if (this.gatewayTypeSelectedValue === "DIGI-WR21")
      this.gatewayTypeSelectedId = 2;
    else if (this.gatewayTypeSelectedValue === "DIGI-EX12")
      this.gatewayTypeSelectedId = 3;
    else if (this.gatewayTypeSelectedValue === "DIGI-EX15")
      this.gatewayTypeSelectedId = 4;
    else if (this.gatewayTypeSelectedValue === "Otis Mobiline")
      this.gatewayTypeSelectedId = 5;
    else if (this.gatewayTypeSelectedValue === "BD")
      this.gatewayTypeSelectedId = 1;
    this.txtGWMlIccId = (rowSelectedData["gatewayIccId"] !== null && rowSelectedData["gatewayIccId"] !== undefined) ? rowSelectedData["gatewayIccId"] : "";
    this.txtGWMlIccId2 = (rowSelectedData["gatewayIccId2"] !== null && rowSelectedData["gatewayIccId2"] !== undefined) ? rowSelectedData["gatewayIccId2"] : "";
    if (rowSelectedData["cpidUuid2"] !== null && rowSelectedData["cpidUuid2"] !== undefined && rowSelectedData["cpidUuid2"] !== "")
      this.isDoubleDeck = true;
    if (this.gatewayTypeSelectedId != 5) {
      this.isCGW = false;
      this.getGatewayFirmwareVersionName(this.gatewayTypeSelectedId);
    }
  }

  //Gateway Type drop down seletion changed in modal pop up
  gatewayTypeSelectChanged($event) {
    this.txtGWMlIccId = '';
    this.lblErrorGWMLMacAdd = "";
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.verizonDeviceInfo = [];
    this.attDeviceInfo = [];
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;
    this.gatewayTypeSelectedId = $event.target.value;
    this.gatewayTypeSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    this.gatewayTypeSelectedValue === "DIGI-WR21" ? this.txtGWMlMacAdd = "00042D" : (this.gatewayTypeSelectedValue === "DIGI-EX12" ? this.txtGWMlMacAdd = "002704" : (this.gatewayTypeSelectedValue === "DIGI-EX15" ? this.txtGWMlMacAdd = "002704" : this.txtGWMlMacAdd = ""));
    this.TxtGMfwVersion = "";
    if (this.gatewayTypeSelectedId != 5) {
      this.isCGW = false;
      this.getGatewayFirmwareVersionName(Number(this.gatewayTypeSelectedId));
    }
    else {
      this.isCGW = true; this.onGatewayDeviceSearch();
    }
  }

  fnBindBuildingdatabyUnitNumber() {
    this.tempDataList = [];
    this.selectedUnits = [];
    this.apiService
      .getBuildingUnits(this.unitNumber)
      .subscribe((data: any) => {
        for (var val of data.units) {
          this.selectedUnits.push(val['unitNumber']);
          this.tempDataList.push({ "elevatorUnitNumber": val['unitNumber'], "buildingName": data.buildingName, "cpidUuid": val['cpidUuid'], "countryId": this.countryId, "gatewayMacAddress": data.gatewayMacAddress });
        }
        this.rowSelectedData = this.tempDataList;
      });
  }
  //Gateway Firmware Type drop down seletion changed in modal pop up
  fmGatewayTypeSelectChanged($event) {
    this.gatewayTypeSelectedId = $event.target.value;
    this.gatewayTypeSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    (this.gatewayTypeSelectedValue === "DIGI-WR21") ? this.txtGWMlMacAdd = "00042D" : this.txtGWMlMacAdd = "";
  }

  fmOOCVersionSelectChanged($event) {
    this.TxtGMfwVersion = $event.target.value;
  }

  //Reset filters
  resetFilters() {
    this.bindDefaultValuesOnPageLoad();
    this.bindGridOnPageLoad();
    this.txtGWSrchUnit = "";
  }

  resetAfterGatewayAssign() {
    this.modalClose();
    this.bindGridOnPageLoad();
    this.getGridDataByFilterSearch();
    this.rowSelectedData = {};
    this.selectedUnitsInfo = [];
    this.isRowSelected = false;
    this.gatewayUpdateEnable = true;
    this.isValidSerialNumber = true;
  }

  checkDigiFirmwareVersion() {
    if (this.txtGWMlMacAdd.length > 6) {
      this.apiService
        .getDigiFirmwareVersion(this.txtGWMlMacAdd)
        .subscribe((data: any) => {
          this.txtSuggestedVersion = data;
          this.DisplayValidMessages();
          if (this.txtSuggestedVersion == '' || this.txtSuggestedVersion == null) {
            setTimeout(() => {
              this.lblVersionMessage = "Firmware version not reported to DRM. Make sure Digi is online. Click on Get Firmware Version to check DRM status.";
              this.isBtnEndGateway = false;
            }, 5000);
          }
          else if (this.TempTxtGMfwVersion.replace(/ /g, '').split(',').indexOf(this.txtSuggestedVersion) > -1) {
            this.lblVersionMessage = "This Gateway has compatible firmware listed in DRM.";
            this.isBtnEndGateway = true;
          }
          else {
            setTimeout(() => {
              this.lblVersionMessage = "Running Firmware Version from DRM & Otis ONE Compatible Firmware versions are different. Manually update firmware if needed. Click on Get Firmware Version to check Gateway reported version to DRM.";
              this.isBtnEndGateway = false;
            }, 5000);
          }
        });
    }
  }

  invokeFirmwareProgress(displayMessage = true) {
    if (this.progress >= 0 && this.progress < 100) {
      this.checkFirmwareProgress(displayMessage);
    }
    else {
      if (displayMessage) {
        this.toastr.showSuccess("Firmware Installation completed successfully !!");
      }
    }
  }

  checkFirmwareProgress(displayMessage = true) {
    if (this.txtGWMlMacAdd.length > 6) {
      this.apiService
        .getFirmwareProgress(this.txtGWMlMacAdd)
        .subscribe((data: any) => {
          this.progress = data;
          if (this.progress == 100) {
            if (displayMessage) { this.toastr.showSuccess("Firmware Installation completed successfully !!"); }
          }
        });
    }
  }

  onUpdateFirmware($event) {
    this.checkDigiFirmwareVersion();
    this.invokeFirmwareProgress(false);
  }

  onUpdateFirmwareinDRM($event) {
    if (this.TxtGMfwVersion.indexOf('|') > -1) {
      this.toastr.showError("Please select Otis ONE Compatible Firmware Version");
      return;
    }
    this.assignGateway.elevatorUnitNumber = this.selectedUnits;
    this.assignGateway.gatewayType = this.gatewayTypeSelectedValue;
    this.assignGateway.gatewayMacAddress = this.txtGWMlMacAdd;
    this.assignGateway.simcardIccId = this.txtGWMlIccId;
    this.assignGateway.simcardIccId2 = this.txtGWMlIccId2;
    this.assignGateway.buildingName = this.rowSelectedData[0]["buildingName"];
    this.assignGateway.buildingAddress = this.rowSelectedData[0]["buildingAddress"];
    this.assignGateway.communicationType = "";
    this.assignGateway.countryId = this.rowSelectedData[0]["countryId"];
    this.assignGateway.password = this.txtGWPwd;
    this.assignGateway.createdBy = "FCAdmin";
    this.assignGateway.createdDate = this.date.toDateString();
    this.assignGateway.deviceGatewayTypeId = this.devicegatewayTypeSelId;
    this.assignGateway.firmwareVersion = this.TxtGMfwVersion;
    this.assignGateway.OldFirmwareVersion = this.txtSuggestedVersion;
    this.apiService
      .updateFirmwareVersioninDRM(this.assignGateway)
      .subscribe((data: any) => {
        this.rowData = data;
        if (data == true) {
          this.toastr.showSuccess("Gateway firmware version updated to DIGI Device !!");
          this.isSavedUpdated = true;
          this.gatewayUpdateEnable = false;
          setTimeout(() => {
            this.checkDigiFirmwareVersion();
            this.progress = 0;
            this.invokeFirmwareProgress();
          }, 10000);
        }
        else {
          this.toastr.showError("Gateway firmware version update in DRM Failed !!");
        }
      });
  }

  DisplayValidMessages() {
    if (this.txtSuggestedVersion == "" || this.txtSuggestedVersion == null) {
      this.toastr.showInformation("Firmware version not reported to DRM. Make sure Digi is online.");
    }
    else {
      this.toastr.showSuccess("Successfully retrieved the firmware version from DRM !!");
    }
  }
  //Gateway Assign Button click event in Modal Popup
  onAssignGateway($event) {
    if ($event != null) {
      if (this.assignGatewayValidations()) {        
        if (this.lblICCID1error != "") {
                    this.txtGWMlIccId = "";
                    this.lblICCID1error = "";
                    this.isInvalidSim1 = true;
        }
        if (this.lblICCID2error != "") {
          this.txtGWMlIccId2 = "";
          this.lblICCID2error = "";
          this.isInvalidSim2 = true;
        }
        this.assignGateway.elevatorUnitNumber = this.selectedUnits;
        this.assignGateway.gatewayType = this.gatewayTypeSelectedValue;
        this.assignGateway.gatewayMacAddress = this.txtGWMlMacAdd;
        this.assignGateway.simcardIccId = this.txtGWMlIccId;
        this.assignGateway.simcardIccId2 = this.txtGWMlIccId2;
        this.assignGateway.buildingName = this.rowSelectedData[0]["buildingName"];
        this.assignGateway.buildingAddress = this.rowSelectedData[0]["buildingAddress"];
        this.assignGateway.communicationType = "";
        this.assignGateway.countryId = this.rowSelectedData[0]["countryId"];
        this.assignGateway.password = this.txtGWPwd;
        this.assignGateway.createdBy = "FCAdmin";
        this.assignGateway.createdDate = this.date.toDateString();
        this.assignGateway.deviceGatewayTypeId = this.devicegatewayTypeSelId;
        this.assignGateway.firmwareVersion = "";
        this.assignGateway.OldFirmwareVersion = this.txtSuggestedVersion;

        this.apiService
          .assignGateway(this.assignGateway)
          .subscribe({
            next: (data) => {
              this.lblICCID1success = "";
              this.lblICCID2success = "";
              this.rowData = data;
              if (data != null && (data == true || data.item1 == true)) {
                this.toastr.showSuccess("Gateway commissioned successfully !!");
                if (data.item1 != undefined) {                 
                  if (data.item3 != null && data.item3 != "" && this.txtGWMlIccId.length === 20) {
                    this.isATTActivation = true;
                    this.lblATTStatus = "AT&T SIM Card Successfully Activated.";
                  }
                  else if ((data.item3 == null || data.item3 == "") && this.txtGWMlIccId !== "") {
                    this.isATTActivation = false;
                    this.txtGWMlIccId = "";
                    this.lblATTStatus = "AT&T SIM Card Activation Failed.";
                  }
                  if (data.item2 != null && data.item2 != "" && this.txtGWMlIccId2.length === 20) {
                    this.isVerizonActivation = true;
                    this.lblVerizonStatus = "Verizon SIM Card activation is currently in progress. Please wait 3–5 minutes and check the status on this screen.";
                    setTimeout(() => {
                      if (this.txtGWMlIccId2.trim() !== "" && this.txtGWMlIccId2.trim().length == 20) {
                        this.checkVerizonDeviceAvailability();
                      }
                    }, 300000);
                  }
                  else if ((data.item2 == null || data.item2 == "") && this.txtGWMlIccId2 !== "") {
                    this.isVerizonActivation = false;
                    this.txtGWMlIccId2 = "";
                    this.lblVerizonStatus = "Verizon SIM Card Activation Failed.";
                  }
                }
                this.isSavedUpdated = true;
                this.gatewayUpdateEnable = false;                 
                    if (!this.gatewayUpdateEnable && this.isInvalidSim1) {
                      setTimeout(() => {
                        this.toastr.showInformation("SIM ICCID1 not found in the AT&T system. Please update SIM details offline");
                        this.isInvalidSim1 = false;
                      }, 5000);
                    }
                     if (!this.gatewayUpdateEnable && this.isInvalidSim2) {
                      setTimeout(() => {
                        this.toastr.showInformation("SIM ICCID2 not found in the Verizon system. Please update SIM details offline");
                        this.isInvalidSim2 = false;
                      }, 5000);
                    }
                this.getUnitDeviceGateway(true);
                if (this.gatewayTypeSelectedId != 5) {
                  setTimeout(() => {
                    this.checkDigiFirmwareVersion();
                  }, 10000);
                  setTimeout(() => {
                    this.invokeFirmwareProgress();
                  }, 5000);
                }
              }
              else {
                this.toastr.showError("Gateway Commission Failed !!");
              }
            },
            error: (err) => {
              if (err.error != null && err.error == "G3MS: API Call to G3MS failed") {
                this.toastr.showSuccess("Gateway commissioned successfully !!");
                this.isATTActivation = true;
                this.lblATTStatus = "AT&T SIM Card Successfully Activated.";
                this.isVerizonActivation = true;
                this.lblVerizonStatus = "Verizon SIM Card activation is currently in progress. Please wait 3–5 minutes and check the status on this screen.";
                setTimeout(() => {
                  if (this.txtGWMlIccId2.trim() !== "" && this.txtGWMlIccId2.trim().length == 20) {
                    this.checkVerizonDeviceAvailability();
                  }
                }, 300000);
                this.isSavedUpdated = true;
                this.gatewayUpdateEnable = false;
                this.getUnitDeviceGateway(true);
                this.lblG3MSErrorMessage = "API Call to G3MS is Failed. Please Update Gateway Serial Number in G3MS";
              }
            },
          });
      }
    }
    else {
      this.toastr.showError("Please select uncommission gateway unit");
    }
  }

  assignGatewayValidations(): boolean {
    this.txtGWMlMacAdd = this.txtGWMlMacAdd.replace(/\:/g, "").trim();

    if (this.txtGWMlMacAdd.length !== 12) {
      this.lblErrorGWMLMacAdd = (this.gatewayTypeSelectedId != 5 ? "Gateway Mac Address" : "Gateway Serial Number") + " should be 12 characters length";
      return false;
    }
    else {
      this.lblErrorGWMLMacAdd = "";
    }
    return true;
  }

  //Get gateway types
  getGatewayTypes() {
    this.masterDataService
      .getGatewayType()
      .subscribe((data: any) => {
        this.gatewayTypes = data;
        this.DefaultGatewayTypeText = this.gatewayTypes.filter(x => x.id == this.DefaultGatewayTypeId)[0]?.name;
        this.DefaultGatewayTypeText === "DIGI-WR21" ? this.DefaultMacAddress = "00042D" : (this.DefaultGatewayTypeText === "DIGI-EX12" ? this.DefaultMacAddress = "002704" : (this.DefaultGatewayTypeText === "DIGI-EX15" ? this.DefaultMacAddress = "002704" : this.DefaultMacAddress = ""));
      });
  }

  //Get Country data
  getCountries() {
    this.masterDataService
      .getCountries()
      .subscribe((data: any) => {
        this.countries = data;
      });
  }

  //Get the gateway firmware version
  getGatewayFirmwareVersion() {
    this.apiService
      .getGatewayFirmwareVersion()
      .subscribe((data: any) => {
        this.GWFMVersion = data;
        this.gatewayTypeSelectedId = this.DefaultGatewayTypeId;
        const emptyVersionData = this.getEmptyGatewayFirmwareVersion(this.gatewayTypes, data);
        if (emptyVersionData != null && emptyVersionData.length > 0) {
          emptyVersionData.forEach(element => {
            this.GWFMVersion.push({
              gatewayTypeId: element.id,
              name: element.name,
              firmwareVersion: "N/A",
              createdBy: "N/A"
            })
          });
        }
        this.getGatewayFirmwareVersionName(this.gatewayTypeSelectedId);
      });
  }

  getUnitDeviceGateway(isgateway) {
    this.apiService
      .getUnitDeviceGatewayType(this.unitNumber)
      .subscribe((data: string) => {
        this.unitdeviceGatewayType = data;
        if (this.unitdeviceGatewayType != "CPIB2" && isgateway) { this.fnBindBuildingdatabyUnitNumber(); }
      });
  }

  clearErrorMessages() {
    this.lblErrorGWMLMacAdd = "";
    this.lblErrorGWMLType = "";
    this.lblErrorGWFWVersionAdd = "";
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.isATTActivation = false;
    this.verizonDeviceInfo = [];
    this.attDeviceInfo = [];
  }
  OnDecommissioinGateway() {
    if (this.rowSelectedData[0]["gatewayMacAddress"] !== "" && this.rowSelectedData[0]["gatewayMacAddress"] !== null && this.rowSelectedData[0]["gatewayMacAddress"] !== undefined) {
      this.gatewayDecommission.elevatorUnitNumber = this.rowSelectedData[0]["elevatorUnitNumber"];
      this.gatewayDecommission.gatewayMacAddress = this.rowSelectedData[0]["gatewayMacAddress"];
      this.gatewayDecommission.gatewayType = this.rowSelectedData[0]["gatewayType"];
      this.gatewayDecommission.countryId = this.rowSelectedData[0]["countryId"];
      this.gatewayDecommission.simICCID = this.rowSelectedData[0]["gatewayIccId"];
      this.gatewayDecommission.simICCID2 = this.rowSelectedData[0]["gatewayIccId2"];
      this.gatewayDecommission.unitDeviceGateway = this.unitdeviceGatewayType;

      this.apiService
        .gatewayDeCommission(this.gatewayDecommission)
        .subscribe((data: any) => {
          if (data == true) {
            if (this.unitdeviceGatewayType.toUpperCase() == "CPIB2") {
              this.toastr.showSuccess("Gateway decommission is successful for Unit - " + this.rowSelectedData[0]["elevatorUnitNumber"]);
            }
            else {
              this.toastr.showSuccess("Gateway decommissioned successfully for the Building !!");
            }
            this.isSavedUpdated = true;
            this.modalClose();
            this.bindGridOnPageLoad();
            this.isRowSelected = false;
            this.rowSelectedData = {};
            this.selectedUnitsInfo = [];
          }
          else {
            this.toastr.showError("Decommission Failed !!");
          }
        });
    }
    else {
      this.toastr.showError("Please select the Gateway commissioned unit !!");
    }
  }

  gatewayFirmwareSubmit() {
    if (this.txtGWFirmwareVersion !== undefined)
      this.txtGWFirmwareVersion = this.txtGWFirmwareVersion.replace(/^\s+|\s+$/g, "");
    else
      this.lblErrorGWFWVersionAdd = "Please provide Gateway Firmware version";

    if (!!this.txtGWFirmwareVersion) {
      this.addGatewayFirmware.FirmwareVersion = this.txtGWFirmwareVersion;
      this.addGatewayFirmware.GatewayTypeId = this.gatewayTypeSelectedId;
      this.addGatewayFirmware.IsActive = true;
      this.apiService
        .addGatewayFirmware(this.addGatewayFirmware)
        .subscribe((data: any) => {
          if (data == true) {
            this.toastr.showSuccess("Gateway Firmware version saved successfully!!");
            this.isSavedUpdated = true;
            this.getGatewayFirmwareVersion();
            this.modalService.dismissAll();
            this.txtGWFirmwareVersion = "";
          }
          else {
            this.toastr.showError("Gateway Firmware version saved failed !!");
          }
        });
    } else {
      this.lblErrorGWFWVersionAdd = "Please provide Gateway Firmware version";
    }
  }

  getEmptyGatewayFirmwareVersion(gatewaytype, data) {
    let res = [];
    if (gatewaytype != undefined) {
      res = gatewaytype.filter(el => {
        return !data.find(element => {
          return element.gatewayTypeId === el.id;
        });
      });
      return res;
    }
  }

  getGatewayFirmwareVersionName(gatewayType) {
    var fwversion;
    this.GWFMVersion.forEach(element => {
      fwversion = "";
      if (element.gatewayTypeId === gatewayType) {
        if (element.firmwareVersion.indexOf(',') > -1) {
          //This code will add first element concatenating two versions
          fwversion = element.firmwareVersion.replace(',', '  |  ') + ',';
        }
        this.TempTxtGMfwVersion = fwversion + element.firmwareVersion;
        this.TxtGMfwVersion = this.TempTxtGMfwVersion.split(',')[0];
        return true;
      }
    });
  }

  onKeyPress($event) {
    this.txtGWMlMacAdd = this.txtGWMlMacAdd.trim();
    if (this.gatewayTypeSelectedId == 5 && this.txtGWMlMacAdd != null && this.txtGWMlMacAdd != '') {
      var enteredValue = $event.target.value;
      if (enteredValue.length == 12) {
        this.getCGWConnectionStatus();
      }
      else {
        this.onGatewayDeviceSearch();
      }
    }
  }

  onGatewayDeviceSearch() {
    this.txtGWMlIccId = "";
    this.lblErrorGWMLMacAdd = "";
    this.lblConnectionStatus = "";
    this.isOnline = false;
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.attDeviceInfo = [];
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.verizonDeviceInfo = [];
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.isATTActivation = false;
  }

  onATTDeviceSearch() {
    if (!this.txtGWMlIccId) {
      this.lblICCID1error = "";
      this.lblICCID1success = "";
      return;
    }

    this.txtGWMlIccId = this.txtGWMlIccId.replace(/\:/g, "").trim();

    if (this.txtGWMlIccId.length !== 0 && this.txtGWMlIccId.length !== 20) {
      this.lblICCID1error = "AT&T SIM Card ICCID length should be 20 characters";
      this.lblICCID1success = "";
      return false;
    }
    else if (this.txtGWMlIccId.length == 20) {
      this.lblICCID1error = "";
      this.checkATTDeviceAvailability(() => {
        if ((this.attDeviceInfo == null || this.attDeviceInfo.iccid == null || this.attDeviceInfo.iccid == "")) {
          this.lblICCID1error = "Device does not exist in AT&T System";
          this.lblICCID1success = "";
        }
        else if (this.attDeviceInfo.iccid != null && this.attDeviceInfo.iccid != "") {
          this.lblICCID1error = "";
          this.lblICCID1success = "Device exists in AT&T System";
        }
      });
    }
  }

  getCGWConnectionStatus() {
    if (this.txtGWMlMacAdd.length !== 12) {
      this.lblErrorGWMLMacAdd = "Gateway Serial Number should be 12 characters length";
      return false;
    }
    this.lblErrorGWMLMacAdd = "";
    this.apiService
      .getGatewayDeviceStatus(this.txtGWMlMacAdd, this.gatewayTypeSelectedValue)
      .subscribe({
        next: (data: any) => {
          if (data != null && data.message == 'Success' && data.cGWGatewayInfo != null) {
            this.txtGWMlIccId = data.cGWGatewayInfo['simcardIccId'];
            this.lblConnectionStatus = "Connection Status from MMS";
            this.isOnline = data.cGWGatewayInfo['status'] == 'Online' ? true : false;
            this.isValidSerialNumber = true;
            if (this.gatewayTypeSelectedId != 5) {
              this.txtGWMlIccId = "";
              this.lblConnectionStatus = "";
            }
          }
          else {
            this.toastr.showError("Invalid Gateway Serial Number");
          }
        },
        error: (err) => {
          this.isValidSerialNumber = false;
        }
      });
  }

  checkUserPermissions() {
    this.permissionService.loadUserPermissions().subscribe((permissions) => {
      this.enableGatewaySync = permissions['Gateway'] || false;
      this.gatewaySync = this.enableGatewaySync ? "Gateway Sync" : "";
    });
  }

  onVerizonDeviceSearch() {
    this.txtGWMlIccId2 = this.txtGWMlIccId2.replace(/\:/g, "").trim();

    if (this.txtGWMlIccId2.length !== 0 && this.txtGWMlIccId2.length !== 20) {
      this.lblICCID2error = "Verizon SIM Card ICCID length should be 20 characters";
      this.lblICCID2success = "";
      return false;
    }
    else if (this.txtGWMlIccId2.length == 20) {
      this.lblICCID2error = "";
      this.checkVerizonDeviceAvailability(() => {
        if ((this.verizonDeviceInfo == null || this.verizonDeviceInfo.devices == null || this.verizonDeviceInfo.devices.length == 0)) {
          this.lblICCID2error = "Device does not exist in Verizon System";
          this.lblICCID2success = "";
          this.lblVerizonStatus = "";
        }
        else if (this.verizonDeviceInfo.devices != null && this.verizonDeviceInfo.devices.length > 0) {
          this.lblICCID2error = "";
          this.lblICCID2success = "Device exists in Verizon System";
          this.lblVerizonStatus = "";
        }
      });
    }
  }

  checkATTDeviceAvailability(onComplete?: () => void) {
    this.apiService
      .checkATTDeviceStatus(this.txtGWMlIccId.trim())
      .subscribe((data: any) => {
        if (data != null) {
          this.attDeviceInfo = data;
        }
        else {
          this.attDeviceInfo = [];
        }
        if (onComplete) {
          onComplete();
        }

      });
  }

  checkVerizonDeviceAvailability(onComplete?: () => void) {
    this.apiService
      .checkVerizonDevice(this.txtGWMlIccId2.trim())
      .subscribe((data: any) => {
        if (data != null) {
          this.verizonDeviceInfo = data;
        }
        else {
          this.verizonDeviceInfo = [];
        }
        if ((data.devices == null || data.devices.length == 0) && !this.gatewayUpdateEnable) {
          this.lblVerizonStatus = "Verizon SIM Card Activation Failed";
          this.lblICCID2error = "";
          this.lblICCID2success = "";
          this.txtGWMlIccId2 = "";
          this.isVerizonActivation = false;
        }
        else if (data.devices != null && data.devices.length > 0 && !this.gatewayUpdateEnable) {
          this.lblICCID2error = "";
          this.lblICCID2success = "";
          this.lblVerizonStatus = "Verizon SIM Card Successfully Activated";
          this.isVerizonActivation = true;
        }
        if (onComplete) {
          onComplete();
        }

      });
  }
}
